import React from 'react';
import { Checkbox, T } from '@colonist/ui';
import styles from './UsernamePurchaseConfirmation.module.scss';
/* Confirmation checkbox for a username change */ export const UsernamePurchaseConfirmation = ({ changeScenario, confirmed, onConfirmedChange })=>{
    if (changeScenario != 'coins' && changeScenario != 'free') return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.body,
        "data-testid": "username-purchase-confirm"
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        checked: confirmed,
        onChange: onConfirmedChange
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.header.changeUsername.confirm.confirm'
        }
    })));
};
